// extracted by mini-css-extract-plugin
export default {"wrapper":"fT-z","availablePromoMessagesLabel":"gT-z","promoMessageList":"hT-z","promoMessage":"iT-z","appliedPromoMessage":"jT-z","promoMessageAmount":"kT-z"};